<template>
  <component
    :width="width || fallbackWidth"
    :height="height || fallbackWidth"
    :viewBox="viewBox"
    :is="iconComponent"
    class="aha-svg"
    @click="$emit('click', $event)"
    :class="{ 'path-fill-current': !maintainColor }"
  />
</template>

<script>
// import icons from '../../../assets/icons'

const icons = {}
const requireComponents = require.context('../../assets/icons/', false, /.svg$/)

requireComponents.keys().forEach((fileName) => {
  const iconName = fileName.replace(/^\.\/(.+)\.svg$/, '$1')
  const componentConfig = requireComponents(fileName)
  icons[iconName] = componentConfig.default || componentConfig
})

// Following code for Vite, keep here for reference
// const icons = {}

// const modules = import.meta.glob('../../../assets/icons/*.svg')
// const importPromises = Object.keys(modules).map((file) => {
//   return import(/* @vite-ignore */file)
// })

// Promise.all(importPromises).then((allModules) => {
//   Object.keys(modules).forEach((file, index) => {
//     const iconName = file.replace('../../../assets/icons/', '').replace('.svg', '')
//     icons[iconName] = allModules[index].default
//   })
// })

export default {
  props: {
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    maintainColor: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
  },
  computed: {
    iconComponent() {
      return icons[this.name]
    },
    fallbackWidth() {
      if (this.size === 'xs') {
        return 10
      }

      if (this.size === 'sm') {
        return 14
      }

      if (this.size === 'lg') {
        return 20
      }

      if (this.size === 'xl') {
        return 28
      }

      if (this.size === 'xxl') {
        return 32
      }

      return 16
    },
  },
}
</script>

<style lang="scss">
.aha-svg {
  display: inline-block;
}

.path-fill-current path {
  fill: currentColor;
}
</style>
